import {
  useBuyerAppConfig,
  useQueryClient,
  useQueryWithUserId,
} from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

/**
 * React query state key for fetch BIDS DETAILS api it can invalidate
 * the state of bids details
 */
const FETCH_BIDS_DETAILS_QUERY_KEY = 'fetch-bids-details-query-key';

/**
 * This is used to perform query invalidation for bid details
 */
export const useBidDetailsQueryInvalidation = (assetId: string) => {
  const queryClient = useQueryClient();

  const invalidateBidDetails = () => {
    queryClient.invalidateQueries({
      queryKey: [FETCH_BIDS_DETAILS_QUERY_KEY, assetId],
    });
  };

  return {
    /**
     * This is used to perform query invalidation for bid details
     */
    invalidateBidDetails,
  };
};

/**
 * React Query hook for bid details api management it will call
 *`fetchBidDetails` api and give error loading success state with response
 */
export const useBidDetailsQuery = (assetId: string) => {
  const { isRankOneBidDisplayEnabled } = useBuyerAppConfig().bids;
  const { invalidateBidDetails } = useBidDetailsQueryInvalidation(assetId);

  const { data, isError, error, isPending, refetch, isFetching } =
    useQueryWithUserId({
      queryKey: [
        FETCH_BIDS_DETAILS_QUERY_KEY,
        assetId,
        isRankOneBidDisplayEnabled,
      ],
      queryFn: () =>
        BIDS_API.fetchBidDetails(assetId, isRankOneBidDisplayEnabled),
      enabled: !!assetId,
      retry: false,
    });

  return {
    error,
    isError,
    data,
    isPending,
    isFetching,
    invalidateBidDetails,
    refetch,
  };
};
